import { lazy } from 'react';
export const productRegistry = {
    grinder: lazy(()=>import('../pages/products/GrinderPage'))
};
